import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Box, Card, Divider, Link, Stack, Typography } from '@mui/material';
import { JournalByDate } from '../Statistics.types';

interface JournalsTableMobileProps {
  journals: JournalByDate[];
}

export const JournalsTableMobile: React.FC<JournalsTableMobileProps> = ({
  journals,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Stack spacing={12} sx={{ mt: 24 }}>
      {journals.map((row, index) => (
        <Card
          key={`${row.name}-${row.agreement}-${index}`}
          variant="primary"
          sx={{ '&:hover': { cursor: 'default' } }}
        >
          <Stack spacing={2}>
            <Box>
              <Typography variant="caption">
                {t('statistics.table.amount')}
              </Typography>
              <Typography variant="body1" fontWeight={600}>
                {row.count}
              </Typography>
            </Box>
            <Divider />
            <Box>
              <Typography variant="caption">
                {t('statistics.table.agreement')}
              </Typography>
              <Typography variant="body1">
                {row.agreement_id ? (
                  <Link
                    component="button"
                    onClick={(e: React.MouseEvent) => {
                      e.preventDefault();
                      if (e.ctrlKey || e.metaKey) {
                        window.open(
                          `/agreements/${row.agreement_id}`,
                          '_blank'
                        );
                      } else {
                        navigate(`/agreements/${row.agreement_id}`);
                      }
                    }}
                    onKeyDown={(e: React.KeyboardEvent) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        if (e.ctrlKey || e.metaKey) {
                          window.open(
                            `/agreements/${row.agreement_id}`,
                            '_blank'
                          );
                        } else {
                          navigate(`/agreements/${row.agreement_id}`);
                        }
                      }
                    }}
                    tabIndex={0}
                  >
                    {row.agreement_name || row.agreement || '-'}
                  </Link>
                ) : (
                  row.agreement_name || row.agreement || '-'
                )}
              </Typography>
            </Box>
            <Divider />
            <Box>
              <Typography variant="caption">
                {t('statistics.table.name')}
              </Typography>
              <Typography variant="body1">
                {row.url ? (
                  <Link
                    href={row.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {row.name || '-'}
                  </Link>
                ) : (
                  row.name || '-'
                )}
              </Typography>
            </Box>
            <Divider />
            <Box>
              <Typography variant="caption">
                {t('statistics.table.imprint')}
              </Typography>
              <Typography variant="body1">{row.imprint || '-'}</Typography>
            </Box>
            <Divider />
            <Box>
              <Typography variant="caption">
                {t('statistics.table.payment')}
              </Typography>
              <Typography variant="body1">{row.payment || '-'}</Typography>
            </Box>
            <Divider />
            <Box>
              <Typography variant="caption">
                {t('statistics.table.publishingModel')}
              </Typography>
              <Typography variant="body1">
                {row.publishing_model || '-'}
              </Typography>
            </Box>
          </Stack>
        </Card>
      ))}
    </Stack>
  );
};
